import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('multiSelectDroneField');

    return {
        DRONES: t('drones'),
        DRONES_ARE_REQUIRED: t('dronesAreRequired')
    };
};

export default useTranslation;
